export default __webpack_public_path__ + "static/media/clientCase4.276116be.png";